// extracted by mini-css-extract-plugin
module.exports = {"container":"container--mlB66","block":"block--31Zl1","icon":"icon---pfI6","block-title":"block-title--3Q0uf","block-message":"block-message--2DxXH"};